/* Project Import will be here */
import { post, IRequest } from "./index";
import { IChannelMasterParams, IChannelParams, ISubChannelParams } from "models/channelModels";
/* Project Import will be here */

export const getChannelMasterApi = (params: IChannelMasterParams) => {
  const request: IRequest = {
    subUrl: `/Channel/ChannelMaster`,
    ...params
  };
  return post(request);
};

export const getChannelsApi = (params: IChannelParams) => {
  const request = {
    data: {
      chnlid: 0,
      levelId: 0
    },
    headers: params.headers
  };
  return getChannelMasterApi(request);
};

export const getSubChannelsApi = (params: ISubChannelParams) => {
  const request = {
    data: {
      levelId: 1,
      chnlid: params.chnlid
    },
    headers: params.headers
  };
  return getChannelMasterApi(request);
};